import OauthLoginButton from 'screens/LoginOrSignup/components/OauthLoginButton/OauthLoginButton'
import { RegistrationType } from 'screens/LoginOrSignup/utils'

export const GoogleOauth = () => {
  return <OauthLoginButton provider={RegistrationType.Google} workspaceInviteToken="" />
}

export default GoogleOauth
